import { MemberSubscriptionStatus } from '@vista-digital/ocapi-types/v1';
import { addDays, subMonths } from 'date-fns';
import { isDateBetween } from '../../../../utils/is-date-between';
export const isSubscriptionRecurring = (subscription) => {
    return subscription.billingDetails.isRecurring;
};
export const isSubscriptionActive = (subscription) => {
    return subscription.status === MemberSubscriptionStatus.Active;
};
export const isSubscriptionOnHold = (subscription) => {
    return subscription.status === MemberSubscriptionStatus.OnHold;
};
export const isSubscriptionFrozen = (subscription) => {
    return subscription.status === MemberSubscriptionStatus.Frozen;
};
export const didLastSubscriptionPaymentFail = (subscription) => {
    var _a;
    return !!((_a = subscription.billingDetails.billingError) === null || _a === void 0 ? void 0 : _a.willBeRetried);
};
export const hasLastContractedPaymentBeenMade = (subscription) => {
    return !!subscription.billingDetails.hasLastContractedPaymentBeenMade;
};
/**
 * Get the date that an on hold member subscription will reactive.
 */
export const getSubscriptionReactivationDate = (subscription) => {
    var _a;
    const endDate = (_a = subscription.holdPeriod) === null || _a === void 0 ? void 0 : _a.endDate;
    if (!endDate)
        return;
    return addDays(new Date(endDate), 1);
};
/**
 * Get the date a member subscription ends.
 *
 * Note: expiresAt and contractedTermEndsAt should be the same unless the subscription is recurring without a new
 * subscription purchased.
 */
export const getSubscriptionEndDate = (subscription) => {
    const { expiresAt, contractedTermEndsAt, cancelsAt } = subscription;
    if (!!cancelsAt)
        return cancelsAt;
    return expiresAt !== null && expiresAt !== void 0 ? expiresAt : contractedTermEndsAt;
};
export const isSubscriptionExpiringSoon = (subscription, expiringSoonThresholdInMonths) => {
    const membershipEndDate = new Date(getSubscriptionEndDate(subscription));
    const expiryStartDate = subMonths(membershipEndDate, expiringSoonThresholdInMonths);
    const now = new Date();
    const inExpiringRange = isDateBetween(now, expiryStartDate, membershipEndDate);
    return inExpiringRange && !isSubscriptionRecurring(subscription) && !isSubscriptionOnHold(subscription);
};
export const hasSubscriptionBeenCancelled = (subscription) => {
    return !!subscription.cancelsAt;
};
